import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Copy, Check, KeyRound } from 'lucide-react';
import { Card } from '../../components/ui/bootstrap';

const CopyField = ({ label, value }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        setCopied(true);
        toast.success('Copied to clipboard');
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="mb-4">
            <label className="fw-medium mb-1 d-block" style={{ fontSize: 12, color: 'var(--bs-secondary-color)', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                {label}
            </label>
            <div
                className="d-flex align-items-center rounded-3 overflow-hidden"
                style={{
                    background: 'rgba(var(--bs-primary-rgb), 0.04)',
                    border: '1px solid rgba(var(--bs-primary-rgb), 0.15)',
                }}
            >
                <code
                    className="flex-grow-1 px-3 py-2 text-truncate"
                    style={{ fontSize: 13, color: 'var(--bs-body-color)', background: 'transparent', fontFamily: 'monospace' }}
                >
                    {value}
                </code>
                <CopyToClipboard text={value} onCopy={handleCopy}>
                    <button
                        type="button"
                        className="btn d-flex align-items-center gap-1 flex-shrink-0"
                        style={{
                            borderRadius: 0,
                            borderLeft: '1px solid rgba(var(--bs-primary-rgb), 0.15)',
                            padding: '8px 14px',
                            fontSize: 12,
                            fontWeight: 500,
                            color: copied ? 'var(--bs-secondary)' : 'var(--bs-primary)',
                            background: copied ? 'rgba(var(--bs-secondary-rgb), 0.08)' : 'rgba(var(--bs-primary-rgb), 0.06)',
                            transition: 'all 0.2s ease',
                        }}
                    >
                        {copied ? <Check size={14} /> : <Copy size={14} />}
                        {copied ? 'Copied' : 'Copy'}
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    );
};

function APIKeysSection({ orgId, integration }) {
    return (
        <Card className="rounded-4 p-4" shadow>
            <div className="d-flex align-items-center gap-2 mb-4">
                <div
                    className="rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{ width: 36, height: 36, background: 'rgba(var(--bs-primary-rgb), 0.08)' }}
                >
                    <KeyRound size={17} color="var(--bs-primary)" strokeWidth={1.75} />
                </div>
                <div>
                    <h6 className="fw-semibold mb-0 text-body-emphasis">API Credentials</h6>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.78rem' }}>Use these keys to authenticate your API requests</p>
                </div>
            </div>

            <CopyField label="Organisation ID" value={orgId} />
            <CopyField label="Project ID" value={integration.id} />
            <CopyField label="API Key" value={integration.api_key} />
        </Card>
    );
}

export default APIKeysSection;

